import { styled, Theme } from '@material-ui/core/styles';

export const Button = styled('button')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px 32px',
  minHeight: '48px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  /* borderRadius: '16px',*/
  border: 0,
  cursor: 'pointer',
  fontStyle: 'normal',
  fontWeight: 'bold',
  fontSize: '14px',
  lineHeight: '24px',
  minWidth: '140px',
  width: 'fit-content',

  [theme.breakpoints.up('md')]: {
    height: '56px',
    padding: '12px 0',
  },

  '&.wide': {
    width: '100%',
    maxWidth: '540px',
  },

  '&.disabled, &:disabled': {
    backgroundColor: 'inherit',
    border: '1px solid',
    borderColor: theme.palette.text.disabled,
  },

  '&.text': {
    backgroundColor: 'transparent',
    border: 0,
    color: theme.palette.primary.main,
  },

  '&.disabled-opacity': {
    opacity: '0.5',
  },

  '&.light': {
    backgroundColor: theme.palette.primary.light,
  },

  '&.outlined': {
    backgroundColor: theme.palette.primary.contrastText,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
}));

export const Link = styled('a')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '46px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  borderRadius: '16px',
  border: 0,
  cursor: 'pointer',
  fontStyle: 'normal',
  fontSize: '14px',
  lineHeight: '24px',
  minWidth: '140px',

  [theme.breakpoints.up('md')]: {
    height: '54px',
  },

  '&.disabled, &:disabled': {
    backgroundColor: 'inherit',
    border: '1px solid',
    borderColor: theme.palette.text.disabled,
  },

  '&.text': {
    backgroundColor: 'transparent',
    border: 0,
    color: theme.palette.primary.main,
  },

  '&.disabled-opacity': {
    opacity: '0.5',
  },

  '&.light': {
    backgroundColor: theme.palette.primary.light,
  },

  '&.outlined': {
    backgroundColor: theme.palette.primary.contrastText,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
}));

export const Paper = styled('div')(({ theme }) => ({
  padding: '32px',
  maxWidth: '540px',
  background: theme.palette.background.paper,
  boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
  /* borderRadius: '16px', */
  flex: 'none',
  order: 1,
  flexGrow: 0,
  boxSizing: 'border-box',

  [theme.breakpoints.up('md')]: {
    padding: '56px',
  },
}));
